import type { SalesAndResourcesContactPointsContent } from '../types/SalesAndResourcesContactPointsContent';

export function createSalesAndResourcesContactPointsContentPlaceholder(): SalesAndResourcesContactPointsContent {
    const emptyPlain = { kind: 'plainText' as const, key: '', content: '' };
    const emptyMulti = { kind: 'plainMultilineText' as const, key: '', content: '' };
    const emptyImage = { kind: 'image' as const, key: '', imageUrl: '' };
    const emptyRich = { kind: 'richText' as const, key: '', content: '', sanitizedContent: '' };
    const emptyInternalLink = {
        kind: 'internalLink' as const,
        key: '',
        linkText: '',
        linkRoute: '',
    };

    return {
        pageTitle: emptyPlain,
        pageSubtitle: emptyMulti,
        pageTitleBackgroundImage: emptyImage,
        common: {
            regionSelectLabel: emptyPlain,
            regionSelectPlaceholder: emptyPlain,
            countrySelectLabel: emptyPlain,
            countrySelectPlaceholder: emptyPlain,
            subnationalRegionSelectLabel: emptyPlain,
            subnationalRegionSelectPlaceholder: emptyPlain,
            contactPhoneLabel: emptyPlain,
            contactEmailLabel: emptyPlain,
        },
        SalesOffices: { title: emptyPlain },
        Representatives: { title: emptyPlain },
        Distributors: {
            title: emptyPlain,
            globalDistributorsLabel: emptyPlain,
            regionalDistributorsLabel: emptyPlain,
        },
        ContactUs: {
            title: emptyPlain,
            form: {
                fields: {
                    firstNameLabel: emptyPlain,
                    firstNamePlaceholder: emptyPlain,
                    lastNameLabel: emptyPlain,
                    lastNamePlaceholder: emptyPlain,
                    emailLabel: emptyPlain,
                    emailPlaceholder: emptyPlain,
                    phoneNumberLabel: emptyPlain,
                    phoneNumberPlaceholder: emptyPlain,
                    companyLabel: emptyPlain,
                    companyPlaceholder: emptyPlain,
                    industryLabel: emptyPlain,
                    industryPlaceholder: emptyPlain,
                    countryLabel: emptyPlain,
                    countryPlaceholder: emptyPlain,
                    topicOptionSales: emptyPlain,
                    topicOptionTechnical: emptyPlain,
                    topicOptionCompliance: emptyPlain,
                    topicLabel: emptyPlain,
                    topicPlaceholder: emptyPlain,
                    productGroupLabel: emptyPlain,
                    productGroupPlaceholder: emptyPlain,
                    productSubgroupLabel: emptyPlain,
                    productSubgroupPlaceholder: emptyPlain,
                    messageLabel: emptyPlain,
                    messagePlaceholder: emptyPlain,
                },
                consents: {
                    privacyDisclosure: emptyRich,
                    dataProcessingConsentLabel: emptyMulti,
                    dataProcessingConsentDetails: emptyRich,
                    newsletterConsentLabel: emptyMulti,
                    withdrawalRightsNotice: emptyRich,
                    privacyPolicyLink: emptyInternalLink,
                },
                submitButtonLabelNormal: emptyPlain,
                submitButtonLabelSubmitting: emptyPlain,
                submitButtonLabelSubmitted: emptyPlain,
            },
        },
    };
}
